import MagicModuleSwitcher from '@client/modules/MagicModuleSwitcher';
import { Page, PageContent } from '@client/style/Shared';
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import Menu from '@client/modules/Menu/Menu';
import CollectionPageSelector from '@client/modules/ListModules/CollectionPageSelector';
import CollectionInfoStore, { ICollectionInfo } from '@client/modules/ListModules/ContentTypeStore';
import { Colors } from '@client/style/Variables';
import SimpleFooter from '@client/modules/Footers/SimpleFooter';
import FilterStore, { IDefaultFilterType } from '@client/modules/ListModules/FilterStore';
import { DateUtils } from '@client/core/utils/DateUtils';
import Site from '@client/store/Site';
import PageHandler, { HistoryState } from '@client/core/PageSwitch/PageHandler';
import { SessionStorage } from '@client/utils/SessionStorage';

const ContentWrapper = styled(PageContent)``;

const ColorWrapper = styled.div<{ $bg?: string }>`
	width: 100%;
	height: 100%;
	z-index: -1;
	background-color: ${props => props.$bg};
	position: fixed;
`;

export default function CollectionPage(props: {
	content?: {
		_prefix: string;
		slug: string;
		collections: ICollectionInfo[];
		_artists: any[];
		_oddTags: IDefaultFilterType[];
		_locationTags: IDefaultFilterType[];
	};
}) {
	const global = Site.use(state => state.global) as any;

	const collectionInfo = CollectionInfoStore.use(state => state.activeInfo);
	const pageRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (props.content) {
			CollectionInfoStore.setCollectionInfo(props.content.collections);
			FilterStore.setTagFilters(props.content._oddTags);
			FilterStore.setLocationFilters(props.content._locationTags);
		}

		FilterStore.setDateFilters(DateUtils.getDaysListFromTo(new Date(global.startDate), new Date(global.endDate)));
	}, []);

	useEffect(() => {
		const pos = SessionStorage.get('scrollPosition_' + window.location.href);
		const height = SessionStorage.get('pageHeight_' + window.location.href);
		if (pos !== null && height !== null && SessionStorage.get('navHistoryState') === HistoryState.REPLACE) {
			const scrollPosition = parseInt(pos || '0');
			const pageHeight = parseInt(height || '0');
			if (scrollPosition > 0 && pageHeight > 0) {
				pageRef.current!.style.height = pageHeight + 'px';
				window.scrollTo(0, scrollPosition);
			}
		} else {
			FilterStore.setView('tile');
		}
	}, []);

	useEffect(() => {
		const state = PageHandler.getInstance().getData<{ filter: Record<string, any> }>();
		if (state?.filter) {
			FilterStore.setInitial({
				...FilterStore.get(),
				view: state.filter.view,
				selectedTagFilters: state.filter.tags,
				selectedDateFilters: state.filter.dates,
				selectedLocationFilters: state.filter.locations,
			});
		}

		const handleFilterChange = () => {
			const state = FilterStore.get();
			PageHandler.getInstance().setData({
				filter: {
					view: state.view,
					tags: state.selectedTagFilters,
					dates: state.selectedDateFilters,
					locations: state.selectedLocationFilters,
				},
			});
		};

		const unsub = FilterStore.sub(handleFilterChange);

		return () => {
			unsub();
		};
	}, []);

	const getContentFromId = (id: string | undefined) => {
		if (!id) return [];

		const modules = props.content?.collections?.filter(item => item.id === id)[0]?.modules;

		return modules ?? [];
	};

	// console.log('collectionInfo', collectionInfo);

	return (
		<Page ref={pageRef}>
			<ContentWrapper>
				<ColorWrapper $bg={collectionInfo?.backgroundColor?.color} />

				<Menu specificColor={Colors.defaultWhite}></Menu>

				<CollectionPageSelector subtitle={collectionInfo?.subtitle} />

				<MagicModuleSwitcher
					modules={collectionInfo ? getContentFromId(collectionInfo.id) : []}
					addedContent={props.content?._artists || undefined}
				/>
				<SimpleFooter />
			</ContentWrapper>
		</Page>
	);
}
